// frontend/src/components/cash-close/SyncHistoryModal.js
import React, { useEffect, useState } from 'react';
import { useTheme, sans, mono, green, red } from '../../tokens';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

export default function SyncHistoryModal({ companyId, open, onClose, onRevertDone }) {
  const t = useTheme();
  const [rows, setRows] = useState([]);
  const [reverting, setReverting] = useState(null);

  useEffect(() => {
    if (!open) return;
    fetch(`${BACKEND_URL}/api/forecast/history?company_id=${companyId}`)
      .then(r => r.ok ? r.json() : [])
      .then(setRows);
  }, [companyId, open]);

  const revert = async (snapshotId) => {
    if (!window.confirm(`Revert to snapshot #${snapshotId}? Creates a new latest version copying the older payload — original snapshots are not deleted.`)) return;
    setReverting(snapshotId);
    try {
      await fetch(`${BACKEND_URL}/api/forecast/revert`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ company_id: companyId, snapshot_id: snapshotId }),
      });
      if (onRevertDone) onRevertDone();
      onClose();
    } finally {
      setReverting(null);
    }
  };

  if (!open) return null;
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.3)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div onClick={e => e.stopPropagation()} style={{ background: t.bgCard, borderRadius: 8, width: 720, maxHeight: '80vh', overflowY: 'auto', padding: 20, fontFamily: sans }}>
        <h3 style={{ marginTop: 0 }}>Forecast sync history</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
          <thead>
            <tr style={{ borderBottom: `1px solid ${t.border}` }}>
              <th style={{ textAlign: 'left', padding: 6 }}>Synced</th>
              <th style={{ textAlign: 'left', padding: 6 }}>By</th>
              <th style={{ textAlign: 'right', padding: 6 }}>Rows</th>
              <th style={{ textAlign: 'right', padding: 6 }}>Warnings</th>
              <th style={{ textAlign: 'left', padding: 6 }}>Hash</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id} style={{ borderBottom: `1px solid ${t.borderLight}`, background: r.is_latest ? '#F0F8F2' : 'transparent' }}>
                <td style={{ padding: 6 }}>{new Date(r.synced_at).toLocaleString()}{r.is_latest && <strong style={{ marginLeft: 6, color: green }}>· current</strong>}</td>
                <td style={{ padding: 6 }}>{r.modified_by_email || '—'}</td>
                <td style={{ padding: 6, textAlign: 'right', fontFamily: mono }}>{r.rows_count}</td>
                <td style={{ padding: 6, textAlign: 'right', fontFamily: mono, color: r.parse_warnings?.length ? red : t.textMuted }}>
                  {r.parse_warnings?.length || 0}
                </td>
                <td style={{ padding: 6, fontFamily: mono, fontSize: 10, color: t.textMuted }}>{r.content_hash?.slice(0, 8)}</td>
                <td style={{ padding: 6, textAlign: 'right' }}>
                  {!r.is_latest && (
                    <button onClick={() => revert(r.id)} disabled={reverting === r.id}
                            style={{ fontSize: 10, padding: '3px 8px', borderRadius: 6, border: `1px solid ${t.border}`, background: t.bgSurface, cursor: 'pointer' }}>
                      {reverting === r.id ? 'Reverting…' : 'Revert'}
                    </button>
                  )}
                </td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan={6} style={{ padding: 20, textAlign: 'center', color: t.textMuted, fontStyle: 'italic' }}>No snapshots yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
